module.exports = __webpack_public_path__ + "img/burger.6d685459.svg";